var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconArrowUpComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'aidb';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-arrow-up").concat(loadingKls, " ").concat(className), width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, rest, { ref: ref }),
        React.createElement("path", { d: "M35.85,29.08l-1.83,1.77c-.2,.2-.52,.19-.72-.01l-9.26-9.52-9.35,9.53c-.2,.2-.52,.2-.72,0l-1.82-1.78c-.2-.2-.2-.52,0-.72l10.63-10.83c.34-.34,.8-.53,1.28-.53,.48,0,.94,.2,1.27,.54l10.53,10.83c.2,.2,.19,.52-.01,.72Z" }));
}
var IconArrowUp = React.forwardRef(IconArrowUpComponent);
export default IconArrowUp;
